// event-bus.js

import Vue from 'vue';

// 创建一个事件总线实例
const EventBus = new Vue();

export default EventBus;